module.exports = __webpack_public_path__ + "static/media/gpv-telehealth-service2.9d2c7c2e.jpg";